module.exports = __webpack_public_path__ + "static/sonots-dae1978e8a3fdfde6e72017eeefeb23a.png";